import { render } from "./DxtAccountStatistics.vue?vue&type=template&id=60ffdd48&scoped=true"
import script from "./DxtAccountStatistics.vue?vue&type=script&lang=js"
export * from "./DxtAccountStatistics.vue?vue&type=script&lang=js"

import "./DxtAccountStatistics.vue?vue&type=style&index=0&id=60ffdd48&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-60ffdd48"

export default script